"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasSkuValue = exports.getSkuKeyValue = exports.formatResponses = exports.getWizardIdParam = exports.getTypeParam = exports.getLandingPageParam = exports.buildComponentsBody = exports.buildRecommendationsBody = exports.buildCreateBody = exports.buildRecommendationsFetchOptions = exports.buildUpdateFetchOptions = exports.buildCreateFetchOptions = exports.leadGenRecommendations = exports.leadGenUpdate = exports.leadGenCreate = void 0;
const monda_1 = require("@simplisafe/monda");
const monet_1 = require("monet");
const path_1 = __importDefault(require("ramda/src/path"));
const prop_1 = __importDefault(require("ramda/src/prop"));
const leadGen_1 = require("../../secrets/leadGen");
const windowScreenSize_1 = require("../../utils/windowScreenSize");
const capture_1 = require("../capture");
const lead_1 = require("../lead");
const leadGenCreate = (request) => (0, lead_1.leadsAPIRequestFactory)(`${leadGen_1.quoteWizardUrl}/capture`, (0, exports.buildCreateFetchOptions)(request));
exports.leadGenCreate = leadGenCreate;
const leadGenUpdate = (request) => (0, lead_1.leadsAPIRequestFactory)(`${leadGen_1.quoteWizardUrl}/capture/${request.leadId}`, (0, exports.buildUpdateFetchOptions)(request));
exports.leadGenUpdate = leadGenUpdate;
const leadGenRecommendations = (request) => (0, lead_1.leadsAPIRequestFactory)(`${leadGen_1.quoteWizardUrl}/recommendation`, (0, exports.buildRecommendationsFetchOptions)(request));
exports.leadGenRecommendations = leadGenRecommendations;
const buildCreateFetchOptions = (params) => ({
    ...lead_1.defaultParams,
    body: JSON.stringify((0, exports.buildCreateBody)(params))
});
exports.buildCreateFetchOptions = buildCreateFetchOptions;
const buildUpdateFetchOptions = (params) => ({
    ...lead_1.defaultParams,
    body: JSON.stringify({
        'locale': process.env.LOCALE,
        'name': (0, path_1.default)(['responses', 'name'], params),
        'phone': (0, path_1.default)(['responses', 'phone'], params)
    })
});
exports.buildUpdateFetchOptions = buildUpdateFetchOptions;
const buildRecommendationsFetchOptions = (params) => ({
    ...lead_1.defaultParams,
    body: JSON.stringify((0, exports.buildRecommendationsBody)(params))
});
exports.buildRecommendationsFetchOptions = buildRecommendationsFetchOptions;
/**
 * Transform a LeadGenCreateParams into what the API expects
 *
 * See:
 * https://simplisafe.atlassian.net/wiki/spaces/FCP/pages/1716027837/Quote+Wizard+Lead+Documentation
 * https://api.qa.commerce.simplisafe.com/release/leads/v1/docs#tag/Quote-Wizard/paths/~1quote-wizard~1capture/post
 *
 * @param LeadGenCreateParams params
 */
const buildCreateBody = (params) => {
    const utmParams = (0, capture_1.getUTMParams)();
    return {
        'completed': 1,
        'email': (0, path_1.default)(['responses', 'email'], params),
        'landing_page': (0, exports.getLandingPageParam)(params),
        'lead_promo_offer': (0, prop_1.default)('leadPromoOffer', params) || null,
        'lead_source_details': (0, prop_1.default)('format', params),
        'lead_source_type': 'quote_wizard',
        'lead_source_version': JSON.stringify(params.leadSourceVersion || {}),
        'lead_type': 'null',
        'locale': process.env.LOCALE,
        'questions': (0, exports.formatResponses)((0, prop_1.default)('responses', params)),
        'show_phone_field': process.env.LOCALE === 'en-GB' && params.showPhoneField ? 1 : 0,
        'type': (0, exports.getTypeParam)(params),
        // eslint-disable-next-line -- browser-monads isn't typed and needs to be switched to browser-monads-ts
        'url_path': window.location.pathname || '',
        'utm_campaign': utmParams.utm_campaign || null,
        'utm_medium': utmParams.utm_medium || null,
        'utm_source': utmParams.utm_source || null,
        'visitor_id': (0, prop_1.default)('visitorId', params),
        'wizard_id': (0, exports.getWizardIdParam)(params)
    };
};
exports.buildCreateBody = buildCreateBody;
/**
 * Transform a LeadGenCreateParams into what the recommendations API expects
 *
 * See https://api.qa.commerce.simplisafe.com/release/leads/v1/docs#tag/Recommendations
 *
 * TODO: refactor this code to pull a list of SKUs at build-time rather than
 * relying on hard-coded data which can result in instability since SKU values
 * can change and be updated in real-time
 *
 * @param LeadGenCreateParams params
 */
const buildRecommendationsBody = (params) => {
    const formatProp = (0, prop_1.default)('format', params);
    const qwType = formatProp === 'embedded' ? 'Embedded' : 'Nav';
    const utmParams = (0, capture_1.getUTMParams)();
    const components = (0, exports.buildComponentsBody)(params);
    return {
        'components': { ...components },
        'email': (0, path_1.default)(['responses', 'email'], params),
        'lead_promo_offer': (0, monda_1.safeProp)('leadPromoOffer', params).orNull(),
        'lead_source_details': formatProp,
        'lead_source_type': 'quote_wizard_recs',
        'lead_source_version': JSON.stringify(params.leadSourceVersion || {}),
        'lead_type': 'null',
        'locale': process.env.LOCALE,
        'source': `${qwType} Quote Wizard - ${(0, windowScreenSize_1.getDeviceType)()}`,
        // eslint-disable-next-line -- browser-monads isn't typed and needs to be switched to browser-monads-ts
        'url_path': window.location.pathname || '',
        'utm_campaign': utmParams.utm_campaign || null,
        'utm_medium': utmParams.utm_medium || null,
        'utm_source': utmParams.utm_source || null,
    };
};
exports.buildRecommendationsBody = buildRecommendationsBody;
// Abstracted out to reduce code complexity
const buildComponentsBody = (params) => {
    const getResponsesSkuKeyValue = (0, exports.getSkuKeyValue)((0, prop_1.default)('responses', params));
    const responsesHaveSkuValue = (0, exports.hasSkuValue)((0, prop_1.default)('responses', params));
    return {
        'auxiliarySiren': responsesHaveSkuValue('SSWS3') ? 1 : 0,
        'bellBox': responsesHaveSkuValue('CA003-01DUK') ? 1 : 0,
        'carbonMonoxideDetector': responsesHaveSkuValue('SSCO3') ? 1 : 0,
        'entrySensor': getResponsesSkuKeyValue('SSES3'),
        'freezeSensor': responsesHaveSkuValue('SSFS3') ? 1 : 0,
        'glassbreakSensor': responsesHaveSkuValue('SSGB3') ? 1 : 0,
        'indoorCam': responsesHaveSkuValue('CM006-01DWW') ? 1 : 0,
        'keyFob': getResponsesSkuKeyValue('SSES3') >= 7 ? 1 : 0,
        'keypad': responsesHaveSkuValue('SSKP3') ? 1 : 0,
        'motionSensor': getResponsesSkuKeyValue('CA001-01DWW'),
        'outdoorCamera': responsesHaveSkuValue('CMOB1') ? 1 : 0,
        'panicButton': responsesHaveSkuValue('SSPB3') ? 1 : 0,
        'simplicam': responsesHaveSkuValue('SSCM2') ? 1 : 0,
        'smokeDetector': responsesHaveSkuValue('SSSD3') ? 1 : 0,
        'videoDoorbellPro': responsesHaveSkuValue('SSDB3') ? 1 : 0,
        'waterSensor': responsesHaveSkuValue('SSWT3') ? 1 : 0
    };
};
exports.buildComponentsBody = buildComponentsBody;
/**
 * 'home' or 'popup' with country optionally prepended
 *
 * @param QuoteWizardFormat format
 * @param string locale
 */
const getLandingPageParam = ({ format }) => {
    const locale = process.env.LOCALE || 'en-GB';
    return format === 'popup'
        ? locale === 'en-GB'
            ? 'uk-popup'
            : 'popup'
        : locale === 'en-GB'
            ? 'uk-home'
            : 'home';
};
exports.getLandingPageParam = getLandingPageParam;
/**
 * 'popup' for GB/popup else null
 *
 * @param QuoteWizardFormat format
 * @param string locale
*/
const getTypeParam = ({ format }) => {
    const locale = process.env.LOCALE || 'en-GB';
    return format === 'popup' && locale === 'en-GB' ? format : null;
};
exports.getTypeParam = getTypeParam;
/**
 * 2/4/6/8 for US embedded/popup and UK embedded/popup
 * Origin is ss_quote_wizard.idnmb; definitely less ideal
 *
 * @param QuoteWizardFormat format
 * @param string locale
 */
const getWizardIdParam = ({ format }) => {
    const locale = process.env.LOCALE || 'en-GB';
    const localeModifier = locale === 'en-GB' ? 4 : 0;
    const formatModifier = format === 'popup' ? 4 : 2;
    return localeModifier + formatModifier;
};
exports.getWizardIdParam = getWizardIdParam;
/**
 * Fun sorting algorithm for Drupal processing. Drupal needs
 * question 12, then question 4, then question 6, then
 * anything else.
 *
 * @param String a
 * @param String b
 */
const sortForDrupalProcessingUK = (a, b) => a === '12' ? -1
    : a === '4' ? -1
        : b === '4' ? 1
            : a === '6' ? -1
                : b === '6' ? 1
                    : 0;
/**
* US sorting is in numerical ascending order, so convert string keys
* to integers and find the difference does the trick
*
* @param String a
* @param String b
*/
const sortForDrupalProcessingUS = (a, b) => {
    const aInt = parseInt(a);
    const bInt = parseInt(b);
    return aInt - bInt;
};
/**
 * Strip out 'email' key and treat the rest as question/answer pairs.
 * Very specifically sort questions '12', '4', and '6' to the top. If Drupal
 * doesn't get them in this specific order it won't tag the lead correctly
 * and no email will be sent.
 *
 * @param Record<string, unknown>[] responses
 */
const formatResponses = (responses) => Object.keys(responses)
    .filter(key => key !== 'email')
    .sort(process.env.LOCALE === 'en-GB' ? sortForDrupalProcessingUK : sortForDrupalProcessingUS)
    .map(key => {
    return {
        'question_choice_id': responses[key],
        'question_id': key
    };
});
exports.formatResponses = formatResponses;
/**
 * Return numeric value of SKU key in object
 *
 * @param Record<string, unknown> responses
 */
const getSkuKeyValue = (responses) => (sku) => monet_1.Maybe.fromUndefined((0, prop_1.default)(sku, responses)).getOrElse(0);
exports.getSkuKeyValue = getSkuKeyValue;
/**
* Return whether SKU exists in any CSV value in object
*
* @param Record<string, unknown> responses
*/
const hasSkuValue = (responses) => (sku) => Object.values(responses)
    .some((val) => {
    return (val).toString()
        .split(',')
        .some(x => x.toLowerCase() === sku.toLowerCase());
});
exports.hasSkuValue = hasSkuValue;
//# sourceMappingURL=index.js.map